<app-grow-container *ngIf="{group: selectedGroup$ | async} as vm" [trigger]="vm.group">
  <ng-container *ngIf="vm.group; else groups">
    <app-control-page-powerlines-group-expanded></app-control-page-powerlines-group-expanded>
  </ng-container>

  <ng-template #groups>
    <ng-container *ngFor="let group of powerlinesGroups$ | async">
      <app-control-page-powerlines-group [group]="group"></app-control-page-powerlines-group>
    </ng-container>
  </ng-template>
</app-grow-container>
